import { agentDeployChatWidgetApi } from "./agent-deploy-chat-widget.api";
import { agentDeploySipApi } from "./agent-deploy-sip.api";
import { agentDeployWhatsappApi } from "./agent-deploy-whatsapp.api";
import { agentsApi } from "./agents.api";
import { anonymizerApi } from "./anonymizer.api";
import { apiKeysApi } from "./api-keys.api";
import { asrApi } from "./asr.api";
import { audioEnhancementApi } from "./audio-enhancement";
import authApi from "./auth.api";
import { billingApi } from "./billing.api";

import { dashboardApi } from "./dashboard.api";

import { integrationApi } from "./integrations.api";
import { knowledgeApi } from "./knowledge.api";
import { llmApi } from "./llm.api";
import { mcpApi } from "./mcp.api";
import { membersApi } from "./members.api";
import { mfaApi } from "./mfa.api";
import { modelPresetApi } from "./model-presets.api";
import { oauthApi } from "./oauth.api";
import { oktaIntegationApi } from "./okta-integration.api";
import { organizationDidApi } from "./organization-did.api";
import { pricingApi } from "./pricing.api";
import { projectsApi } from "./projects.api";
import { settingsApi } from "./settings.api";
import { structuredAnalysisApi } from "./structured-analysis.api";
import { subscriptionApi } from "./subscription.api";
import { threadsApi } from "./threads.api";
import { ttsApi } from "./tts.api";
import { userApi } from "./user.api";
import { waitingListApi } from "./waiting-list.api";
import { webhookApi } from "./webhook.api";
import { whatsappApi } from "./whatsapp.api";

export default {
  auth: authApi,
  apiKeys: apiKeysApi,
  tts: ttsApi,
  asr: asrApi,
  llm: llmApi,
  user: userApi,
  billing: billingApi,
  settings: settingsApi,

  dashboard: dashboardApi,
  agents: agentsApi,
  threads: threadsApi,
  waitingList: waitingListApi,
  members: membersApi,
  mfa: mfaApi,

  integrations: integrationApi,
  oktaIntegration: oktaIntegationApi,
  modelPreset: modelPresetApi,
  pricing: pricingApi,
  projects: projectsApi,
  anonymizer: anonymizerApi,
  knowledge: knowledgeApi,
  whatsapp: whatsappApi,
  audioEnhancement: audioEnhancementApi,
  webhook: webhookApi,
  structuredAnalysis: structuredAnalysisApi,
  subscription: subscriptionApi,
  agentDeployWhatsapp: agentDeployWhatsappApi,
  agentDeployChatWidget: agentDeployChatWidgetApi,
  agentDeploySip: agentDeploySipApi,
  organizationDid: organizationDidApi,
  mcp: mcpApi,
  oauth: oauthApi,
};
